import type { FC, ReactNode } from 'react'

import { CalendarClock, Mail } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button-link'

import {
    CONTACT_EMAIL,
    KVK_NUMMER,
    MAILTO_GESPREK,
    MAILTO_VRAAG,
    ROMAN_PHOTO
} from '@/constants/leesritme'

export const MakerSection: FC = (): ReactNode => {
    return (
        <section id='wie' className='py-20 sm:py-24'>
            <div className='mx-auto max-w-5xl px-5 sm:px-8'>
                <div className='reveal grid items-center gap-8 rounded-[2rem] border border-ink/10 bg-card p-6 shadow-soft sm:p-10 md:grid-cols-[auto_1fr] md:gap-12'>
                    <div className='relative mx-auto w-48 sm:w-56'>
                        <div aria-hidden='true' className='absolute -inset-3 rotate-[-4deg] rounded-[2rem] bg-sun-soft' />

                        <img
                            src={ROMAN_PHOTO}
                            alt='Roman Storck'
                            width={320}
                            height={320}
                            loading='lazy'
                            decoding='async'
                            className='relative aspect-square w-full rounded-[1.75rem] object-cover'
                        />
                    </div>

                    <div>
                        <p className='text-sm font-bold tracking-[0.14em] text-coral-deep uppercase'>
                            Wie maakt Leesritme
                        </p>

                        <h2 className='mt-3 font-heading font-soft text-3xl leading-tight font-semibold text-ink sm:text-4xl'>
                            Gemaakt door een leerkracht.
                        </h2>

                        <p className='mt-4 text-lg leading-relaxed text-muted-foreground'>
                            Leesritme wordt gemaakt door Roman Storck, leerkracht met ervaring in het speciaal basisonderwijs. Bij de start helpt hij je school persoonlijk op weg, en de resultaten bekijken jullie samen.
                        </p>

                        <div className='mt-7 flex flex-wrap items-center gap-3'>
                            <ButtonLink href={MAILTO_GESPREK} variant='accent'>
                                <CalendarClock className='size-4' aria-hidden='true' />
                                Plan 20 minuten met Roman
                            </ButtonLink>

                            <a
                                href={MAILTO_VRAAG}
                                className='inline-flex items-center gap-2 px-2 py-2 text-[0.9375rem] font-semibold text-ink underline decoration-ink/20 underline-offset-4 hover:decoration-ink'
                            >
                                <Mail className='size-4 text-leaf' aria-hidden='true' />
                                {CONTACT_EMAIL}
                            </a>
                        </div>

                        <p className='mt-5 text-sm text-muted-foreground'>
                            KvK {KVK_NUMMER}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
